export default __webpack_public_path__ + "static/media/home_web-sm@2x.279fbc29.webp";